import { svgPaths, facilitySvgPaths, menuSvgPaths, parkingSvgPaths, LogoContainer, EventContainer, MainContainer } from '../../imports/svgPaths';
// import.*from.*imports/svg-8txpwpskyh";
// import.*from.*imports/LogoContainer";
import { BusinessProcessSteps } from '../common/BusinessProcessSteps';
import { BusinessAdvantageCards } from '../common/BusinessAdvantageCards';

// Business Section Title
function Container17() {
  return (
    <div
      className="box-border content-stretch flex flex-col gap-10 items-center justify-start leading-[0] not-italic p-0 relative shrink-0"
      data-name="Container"
    >
      {/* Background Logo Container for Title */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none z-[1] opacity-60">
        <LogoContainer />
      </div>
      
      <div className="font-paperlogy font-extrabold relative shrink-0 text-center text-neutral-950 text-[min(48px,_8vw)] tracking-[-0.96px] z-10">
        <p className="block leading-[normal] font-bold">창업안내</p>
      </div>
    </div>
  );
}



// Business Advantages Container
function Container18() {
  return (
    <div
      className="box-border content-stretch flex flex-col gap-8 items-start justify-start p-0 relative shrink-0 w-full"
      data-name="Container"
    >
      <h3 className="font-paperlogy font-medium text-[min(24px,_5vw)] text-neutral-950 tracking-[-0.48px] font-bold">
        경쟁력
      </h3>
      
      <BusinessAdvantageCards />
    </div>
  );
}

// Business Process Container - BusinessPage의 향상된 버전 사용
function Container19() {
  return (
    <div
      className="box-border content-stretch flex flex-col gap-8 items-start justify-start p-0 relative shrink-0 w-full"
      data-name="Container"
    >
      <h3 className="font-paperlogy font-medium text-[min(24px,_5vw)] text-neutral-950 tracking-[-0.48px] font-bold">
        창업절차
      </h3>
      
      <div className="relative w-full">
        <BusinessProcessSteps />
      </div>
    </div>
  );
}

// Business More Button
function ButtonContainer10({ onBusinessPageClick }: { onBusinessPageClick?: () => void }) {
  return (
    <div
      className="bg-[#cacc2f] hover:bg-[#b8bb28] box-border content-stretch flex flex-row gap-4 items-center justify-center px-6 py-4 relative rounded-[100px] shrink-0 w-60 cursor-pointer transition-all duration-300 ease-in-out hover:scale-105 hover:shadow-lg transform"
      data-name="Button Container"
      onClick={onBusinessPageClick}
    >
      <div className="font-paperlogy font-medium leading-[0] not-italic relative shrink-0 text-[20px] text-left text-neutral-950 text-nowrap tracking-[-0.4px]">
        <p className="adjustLetterSpacing block leading-[normal] whitespace-pre">
          창업안내 더보기
        </p>
      </div>
      <div className="flex h-[14px] items-center justify-center relative shrink-0 w-[14px]">
        <div className="flex-none rotate-[90deg]">
          <div className="relative size-3.5">
            <div className="absolute bottom-1/4 left-[6.7%] right-[6.7%] top-0">
              <svg
                className="block size-full"
                fill="none"
                preserveAspectRatio="none"
                viewBox="0 0 14 11"
              >
                <path
                  d={svgPaths.p3ed61000}
                  fill="var(--fill-0, #333333)"
                  id="Polygon 1"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// Business Section
function Section6({ onBusinessPageClick }: { onBusinessPageClick?: () => void }) {
  return (
    <div
      className="box-border content-stretch flex flex-col gap-20 items-center justify-start pb-0 pt-20 px-0 relative shrink-0 w-full"
      data-name="Section"
    >
      <Container17 />
      <div className="flex flex-col gap-16 lg:gap-24 w-full">
        <Container18 />
        <Container19 />
      </div>
      <div className="flex justify-center w-full">
        <ButtonContainer10 onBusinessPageClick={onBusinessPageClick} />
      </div>
    </div>
  );
}

// Business Background Logo
function BusinessBackground() {
  return (
    <div className="absolute inset-0 flex items-center justify-center opacity-5 pointer-events-none">
      <div className="w-full max-w-4xl flex flex-col items-center space-y-4">
        <div className="text-8xl text-[rgba(0,0,0,0.1)] font-paperlogy font-extrabold leading-none">
          BUGS
        </div>
        <div className="text-6xl text-[rgba(0,0,0,0.1)] font-paperlogy font-extrabold leading-none">
          ADVENTURE
        </div>
        <div className="text-4xl text-[rgba(0,0,0,0.1)] font-paperlogy font-medium">
          디지털 키즈카페
        </div>
      </div>
    </div>
  );
}

interface BusinessSectionProps {
  onBusinessPageClick?: () => void;
}

export function BusinessSection({ onBusinessPageClick }: BusinessSectionProps) {
  return (
    <div
      id="business-section"
      className="bg-[#ececf0] relative shrink-0 w-full"
      data-name="Main Container"
    >
      <div className="overflow-clip relative size-full">
        <BusinessBackground />
        <div className="box-border content-stretch flex flex-col gap-2.5 items-start justify-start left-1/2 px-4 py-[120px] relative translate-x-[-50%] w-[min(1280px,_calc(100vw_-_40px))] z-10">
          <Section6 onBusinessPageClick={onBusinessPageClick} />
        </div>
      </div>
    </div>
  );
}